class LocalStorage {
	static getItem(key) {
		const value = window.localStorage.getItem(key);
		let jsonValue = '';
		try {
			jsonValue = JSON.parse(value);
		} finally {
			return value ? jsonValue || value : null;
		}
	}

	static setItem(key, value) {
		window.localStorage.removeItem(key);
		try {
			window.localStorage.setItem(key, value !== '' ? JSON.stringify(value) : '');
		} catch(err) {
			if (this.isQuotaExceededError(err)) {
				console.log('Local Storage quota exceeded');
			}
		}
	}

	static removeItem(key) {
	  	window.localStorage.removeItem(key);
	}

	static isQuotaExceededError(err) {
		return (
		  err instanceof DOMException &&
		  // everything except Firefox
		  (err.code === 22 ||
			// Firefox
			err.code === 1014 ||
			// test name field too, because code might not be present
			// everything except Firefox
			err.name === "QuotaExceededError" ||
			// Firefox
			err.name === "NS_ERROR_DOM_QUOTA_REACHED")
		);
	}
}
export default LocalStorage;